<template>
    <router-view></router-view>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({

});
</script>

<style lang="less" scoped>

</style>
